<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card>
          <div class="row content-add-btn">
            <div class="col-5" v-if="isCreate()">
              <div class="text-left">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="$router.push('diseases/create')"
                >
                  <em class="fa fa-plus"></em>
                  {{ $t('diseases.diseases_or_plague_add') }}
                </button>
              </div>
            </div>
            <div class="col-12 text-center">
              <hr />
            </div>
            <el-dialog
              v-if="isShow()"
              :title="nameDiseaseSelected"
              :visible.sync="modals.read"
              width="70%"
              top="2%"
            >
              <p>
                {{ $t('common_words.selected_record_info') }}
              </p>
              <div class="card" v-if="rowData">
                <div class="card-body" v-if="rowData">
                  <table class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td
                          :style="'background-color: ' + rowData.color"
                          scope="row"
                        >
                          <h6>
                            <strong>{{ $t('common_words.color') }}:</strong>
                          </h6>
                          {{ rowData.color }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.name') }}:</strong>
                          </h6>
                          {{ rowData.name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('diseases.scientific_name') }}:</strong
                            >
                          </h6>
                          {{ rowData.scientific_name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >¿{{ $t('diseases.plague_or_disease') }}?</strong
                            >
                          </h6>
                          {{ rowData.type_p_e_name }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.observation') }}:</strong
                            >
                          </h6>
                          {{ rowData.observation }}
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.type') }}:</strong>
                          </h6>
                          {{ rowData.type }}
                        </td>
                      </tr>
                      <tr class="shadow-sm" v-if="rowData.catch_type == 1">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{ $t('common_words.level_or_status') }}:</strong
                            >
                          </h6>
                          <span
                            v-for="(status, index) in rowData.disease_statuses"
                            :key="index"
                          >
                            <el-tag type="info"
                              >{{ status.state_number }} -
                              {{ status.disease_status }}</el-tag
                            >
                          </span>
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6
                            style="
                              height: 30px;
                              line-height: 20px;
                              display: inline-flex;
                            "
                          >
                            <strong
                              >{{
                                $t('common_words.photograph_questionmark')
                              }}?</strong
                            >
                            <el-switch
                              class="ml-3"
                              style="display: block"
                              v-bind:value="rowData.photo == 1 ? true : false"
                              active-color="#6BA652"
                              inactive-color="#ff4c4c"
                            >
                            </el-switch>
                          </h6>
                          <!-- {{ rowData.catch_photo }} -->
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6
                            style="
                              height: 30px;
                              line-height: 20px;
                              display: inline-flex;
                            "
                          >
                            <strong>{{ $t('common_words.perimeter') }}?</strong>
                            <el-switch
                              class="ml-3"
                              style="display: block"
                              v-bind:value="
                                rowData.perimeter == 1 ? true : false
                              "
                              active-color="#6BA652"
                              inactive-color="#ff4c4c"
                            >
                            </el-switch>
                          </h6>
                          <!-- {{ rowData.catch_photo }} -->
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6
                            style="
                              height: 30px;
                              line-height: 20px;
                              display: inline-flex;
                            "
                          >
                            <strong>{{ $t('common_words.confirm') }}?</strong>
                            <el-switch
                              class="ml-3"
                              style="display: block"
                              v-bind:value="
                                rowData.confirmation == 1 ? true : false
                              "
                              active-color="#6BA652"
                              inactive-color="#ff4c4c"
                            >
                            </el-switch>
                          </h6>
                          <!-- {{ rowData.catch_photo }} -->
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{
                                $t('common_words.associated_companies')
                              }}:</strong
                            >
                          </h6>
                          <span
                            v-for="(business, index) in rowData.business_names"
                            :key="index"
                          >
                            <el-tag type="info">{{ business }}</el-tag>
                          </span>
                          <el-tag
                            type="warning"
                            v-if="rowData.business_names.length == 0"
                            >{{
                              $t('common_words.no_associated_companies')
                            }}</el-tag
                          >
                        </td>
                      </tr>
                      <tr class="shadow-sm">
                        <td>
                          <h6 class="custom-margin-h6-table">
                            <strong
                              >{{
                                $t('common_words.associated_crops')
                              }}:</strong
                            >
                          </h6>
                          <span
                            v-for="(crop, index) in rowData.crop_names"
                            :key="index"
                          >
                            <el-tag type="info">{{ crop }}</el-tag>
                          </span>
                          <el-tag
                            type="warning"
                            v-if="rowData.crop_names.length == 0"
                            >{{
                              $t('common_words.no_associated_crops')
                            }}</el-tag
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer footer-date-at" v-if="rowData">
                  <p class="text-muted">
                    <small
                      >{{ $t('common_words.created_on') }}:
                      {{ rowData.created_at }}</small
                    >
                  </p>
                </div>
              </div>
            </el-dialog>
          </div>
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                :cell-style="handlecellstyle"
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                max-height="800"
                style="width: 100%"
                :border="true"
              >
                <el-table-column type="index" width="65"></el-table-column>
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                ></el-table-column>
                <el-table-column min-width="110" label="Color">
                  <template slot-scope="props">
                    <div class="text">
                      <span style="mix-blend-mode: difference">{{
                        props.row.color
                      }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('common_words.photograph_questionmark')"
                  :min-width="110"
                >
                  <template slot-scope="props">
                    <el-switch
                      style="min-height: 40px"
                      v-bind:value="props.row.photo == 1 ? true : false"
                      active-color="#6BA652"
                      inactive-color="#ff4c4c"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="`${$t('common_words.perimeter')}:?`"
                  :min-width="110"
                >
                  <template slot-scope="props">
                    <el-switch
                      style="min-height: 40px"
                      v-bind:value="props.row.perimeter == 1 ? true : false"
                      active-color="#6BA652"
                      inactive-color="#ff4c4c"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="`${$t('common_words.confirm')}:?`"
                  :min-width="130"
                >
                  <template slot-scope="props">
                    <el-switch
                      style="min-height: 40px"
                      v-bind:value="props.row.confirmation == 1 ? true : false"
                      active-color="#6BA652"
                      inactive-color="#ff4c4c"
                    >
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isShow() || isUpdate() || isDelete()"
                  :min-width="120"
                  :label="$t('common_words.operations')"
                  fixed="right"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <a
                        v-if="isShow()"
                        v-tooltip.top-center="$t('common_words.view')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="handleView(props.$index, props.row)"
                      >
                        <em class="fa fa-eye custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.edit')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="handleEdit(props.$index, props.row)"
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isShow() && props.row.fao_doc != null"
                        :href="props.row.fao_doc"
                        target="_blank"
                        v-tooltip.top-center="$t('common_words.see_spec_sheet')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                      >
                        <em class="fa fa-solid fa-download"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
      </div>
    </div>
    <div class="row" style="padding-right: 13px; padding-left: 13px">
      <div class="col-6" v-if="isPDF()">
        <div class="text-right">
          <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
            <em class="fa fa-file-pdf-o"></em>
            {{ $t('common_words.export_to_pdf') }}
          </button>
        </div>
      </div>
      <div class="col-6" v-if="isExcel()">
        <div class="text-left">
          <button
            class="btn custom-btn-success custom-shadow-btn"
            @click="exportToExcel"
          >
            <em class="fa fa-file-excel-o"></em>
            {{ $t('common_words.export_to_excel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './diseaseTable';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().search,

    nameDiseaseSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },
  data() {
    return {
      diseaseForm: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = '/diseases/edit';
      this.diseaseForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.diseaseForm));
      this.$router.push({
        path: 'diseases/edit',
      });
    },

    handleDelete(index, row) {
      this.diseaseForm = Object.assign({}, row);
      SweetAlert.delete(
        i18n.t('diseases.the_plague_or_disease') + this.diseaseForm.name
      ).then((result) => {
        if (result.value) this.deleteDisease();
      });
    },

    handlecellstyle({ row, columnIndex }) {
      if (row.color && columnIndex == 6) {
        return 'background-color: ' + row.color;
      }
    },

    deleteDisease() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.diseaseForm.route = 'diseases/diseases';
        Axios.destroyMaster(this.diseaseForm)
          .then((response) =>
            this.modifyTable(2, this.diseaseForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      let data = {};
      data.route = 'diseases/diseases/pdf';
      data.name_file = `${i18n.t('diseases.diseases')}.pdf`;
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      let data = {};
      data.route = 'diseases/diseases/excel';
      data.name_file = `${i18n.t('diseases.diseases')}.xlsx`;
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('diseases/diseases/')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('diseases/diseases');
  },

  destroyed() {
    this.deselectedItemOnMenu('diseases/diseases');
  },
};
</script>
<style></style>
